export default __webpack_public_path__ + "static/media/check mark.d2da5457.svg";